import { useTranslation } from "react-i18next";
import { RotateCcw, Trash2 } from "lucide-react";

export interface UndoToastProps {
  message: string;
  onUndo: () => void;
  onDismiss: () => void;
}

/**
 * A destructive action plus its reversal, in one place.
 *
 * Removing a widget used to be silent and final — the only recovery was
 * remembering which widget it was and re-adding it from the library at its
 * default size and the wrong position. An undo that restores the exact placement
 * at its exact index is what makes the canvas safe to experiment with, which is
 * the whole point of a canvas you can rearrange.
 */
export const UndoToast = ({ message, onUndo, onDismiss }: UndoToastProps) => {
  const { t } = useTranslation(["common"]);

  return (
    <div className="widget-chrome flex items-center gap-3 rounded-full py-1.5 pe-1.5 ps-3">
      <span className="flex items-center gap-2 text-xs font-medium text-foreground">
        <Trash2 size={13} aria-hidden className="text-muted-foreground" />
        {message}
      </span>
      <button
        type="button"
        onClick={() => {
          onUndo();
          onDismiss();
        }}
        className="widget-target widget-focus flex items-center gap-1 rounded-full bg-primary px-2.5 py-1 text-widget-label font-semibold text-primary-foreground transition-opacity hover:opacity-90"
      >
        <RotateCcw size={11} aria-hidden />
        {t("common:buttons.undo")}
      </button>
    </div>
  );
};
